import * as React from 'react';

function SvgIconSubtitlePlaceholder(props) {
  return (
    <svg width={208} height={88} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#D8E6E2" d="M16 18h85v8H16z" />
      <path fill="#FEEA52" d="M16 34h120v6H16z" />
      <path fill="#D8E6E2" d="M16 48h176v2H16zm0 10h176v2H16zm0 10h176v2H16z" />
    </svg>
  );
}

export default SvgIconSubtitlePlaceholder;
